module.exports = __webpack_public_path__ + "static/media/mobile-auditorium.e0763363.webp";